import React from "react";
import "./header.css";

// Simplified header per customization request.
const Header = () => {
  return (
    <div className="header" style={{ padding: "0.5em 0" }}>
      <h1 style={{ margin: 0 }}>Free mapart bot 6b6t</h1>
      <p style={{ margin: "0.5em 0 0" }}>
        you should be on the discord to get your mapart <a href="https://discord.gg/95uGvg2E2C" target="_blank" rel="noopener noreferrer">Join server</a>
      </p>
    </div>
  );
};

export default Header;
